import React from 'react'
import classNames from 'classnames'

interface IToolbarProps {
  className?: string
  children?: React.ReactNode
}

const Toolbar: React.FC<IToolbarProps> = ({className, children}) => {
  const css = classNames('ac-task-toolbar', className)
  return <div className={css}>{children}</div>
}

export {Toolbar}
